import React from 'react';
import LazyImage from 'components/UI/LazyImage';
import Link from 'components/UI/Link';

import * as styles from './Card.module.scss';

export default function Card({ title, link, icon }) {
  return (
    <Link key={title} href={link} className={styles.link}>
      <figure className={styles.figure}>
        <LazyImage src={icon} alt={title} className={styles.img} />
        <figcaption className={styles.figcaption}>{title}</figcaption>
      </figure>
    </Link>
  );
}
